import { Typography } from '@mui/material';

import { useChainLabelStyles } from './useChainLabelStyles';

interface ArchiveLabelProps {
  label: string;
  labelClassName?: string;
}

export const ChainLabel = ({ label, labelClassName }: ArchiveLabelProps) => {
  const { classes, cx } = useChainLabelStyles();

  return (
    <div className={classes.root}>
      <Typography
        className={cx(classes.label, labelClassName)}
        color="textSecondary"
        component="div"
        variant="body4"
      >
        <span>{label}</span>
      </Typography>
    </div>
  );
};
